<template>
  <div class="storeTasks">
      <el-dialog
        :title="$t('other.a2633')"
        :visible.sync="dialogVisible3"
        :close-on-click-modal='false'
        width="50%"
        >
        <div class="msgBox">
        <div class="chatArea">    
        <el-scrollbar style="height:300px;">
              <div :class="{'msgWrap':true,'sellerMsg':true}"  v-for="(item,index) in chatList" :key="index">
                    <div >
                        <div style="margin-top:8px;"><span>{{type[item.type]}}</span><span style="font-size:10px;margin: 0 10px;">{{showTime(item.createTime)}} </span></div>
                        <div style="padding-top:5px"><i class="iconfont icon-kehuAx"></i><span class="contentBox">{{item.content}}</span></div>
                        
                    </div>
                    <!-- <div v-if="item.type == 2">
                        <div><span class="contentBox">{{item.content}}</span><i class="iconfont icon-kehuAx"></i></div>
                        <div style="font-size:10px;margin: 0 38px;"><span>{{type[item.type]}}</span> {{showTime(item.createTime)}}</div>
                    </div> -->
                </div>
          </el-scrollbar>
          </div>
          <div class="sendBox">
            <el-input style="margin-top:10px;" type="textarea" rows="3" :placeholder="$t('other.a2646')" v-model="textarea3"></el-input>
            <!-- <div class="bbnt">
                <el-button size="mini"  type="info" @click="dialogVisible3 =false">{{$t('other.a5')}}</el-button>
                <el-button size="mini"  type="primary" @click="sendMsg()">发 送</el-button>
            </div> -->
          </div>
        </div>
        <span slot="footer" class="dialog-footer">
            <el-button @click="dialogVisible3 = false">{{$t('other.a106')}}</el-button>
            <el-button type="primary" @click="sendMsg()">{{$t('other.a2647')}}</el-button>
        </span>
        </el-dialog>
      
      <el-dialog
        :title="$t('other.a2634')"
        :visible.sync="dialogVisible2"
        :close-on-click-modal='false'
        width="30%"
        >
        <div>
            {{$t('other.a2648')}}：
            <el-select v-model="finishValue" @change="getTaskType()" :placeholder="$t('other.a2635')">
            <el-option :label="item.label" :value="item.value" v-for="(item,index) in finishStatus" :key="index"></el-option>
            </el-select>
        </div>
        <span slot="footer" class="dialog-footer">
            <el-button @click="dialogVisible2 = false">{{$t('other.a106')}}</el-button>
            <el-button type="primary" @click="storeComfir()">{{$t('other.a279')}} </el-button>
        </span>
        </el-dialog>
      <el-dialog
        :title="$t('other.a2636')"
        :visible.sync="dialogVisible"
        :close-on-click-modal='false'
        width="50%"
        >
        <div>
            <el-form :model="ruleForm"  ref="ruleForm" label-width="100px" class="demo-ruleForm">
            <el-form-item :label="$t('other.a2637')" prop="region" v-if="taskTypeitem">
                <p>{{taskTypeitem.taskName}}</p>
            </el-form-item>
            <el-form-item :label="$t('other.a653')" prop="region">
                <el-select size="mini" v-model="region.storeId"  :placeholder="$t('other.a653')">
                <el-option :label="item.storeName" :value="item.storeId" v-for="(item,index) in store" :key="index"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item :label="$t('other.a2638')" prop="region" v-if="taskTypeitem">
                <p>{{taskTypeitem.taskExplain}}</p>
            </el-form-item>
        
            <el-form-item :label="$t('other.a2639')" prop="region" v-if="taskTypeitem">
                <span>{{$t('other.a2649')}}：{{taskTypeitem.charge}} {{$t('other.a54')}}</span>，
                <span>{{$t('other.a2650')}}：{{taskTypeitem.unfinishedCharge}} {{$t('other.a54')}}</span>
            </el-form-item>

            <el-form-item :label="$t('other.a2640')" prop="region" v-if="taskTypeitem">
                <el-input type="textarea" v-model="ruleForm.contents[0].content"></el-input>
            </el-form-item>
            </el-form>
        </div>
        <span slot="footer" class="dialog-footer">
            <el-button @click="dialogVisible = false">{{$t('other.a106')}}</el-button>
            <el-button type="primary" @click="createTask()">{{$t('other.a279')}} </el-button>
        </span>
        </el-dialog>
      <div class="title">{{$t('aside.zhenzifuwu')}}</div>
      <div style="margin-top:20px;">
          <p class="test">{{$t('other.a2651')}}</p>
          <p class="test">{{$t('other.a2652')}}</p>
          <p class="test">{{$t('other.a2653')}} </p>
      </div>

      <div class="oiuk" v-if="isSeller">
          <div >
              <div class="tgrf">
                  {{$t('other.a2654')}}：
                <span :class="{'taskItem':true,'active':index == activeList[0]}" v-for="(item,index) in countryOptions" :key="index" @click="getTaskType(item.value,index),$set(activeList,0,index)">{{item.label}}</span>
              </div>

              <div class="tgrf">
                  {{$t('other.a2637')}}：
                <span :class="{'taskItem':true,'active':index01 == activeList[1]}" v-for="(task,index01) in taskNameList" :key="index01" @click="$set(activeList,1,index01),taskmainItem=task">
                    {{task.taskName}}
                    <el-tooltip class="item" effect="dark" :content="task.taskExplain" placement="top-start">
                        <i class="el-icon-question oook"></i>
                    </el-tooltip>
                    
                </span>
              </div>
              <div class="tgrf">
                  {{$t('other.a2655')}}：
                <span v-if="taskmainItem" class="taskItem">{{$t('other.a2656')}}：{{taskmainItem.charge}}{{$t('other.a54')}}</span>
                <span v-if="taskmainItem" class="taskItem">{{$t('other.a2657')}}：{{taskmainItem.unfinishedCharge}}{{$t('other.a54')}}</span>
              </div>
              
              <div class=" poom" style="margin-right:30px;">
                  <el-button  type="danger" @click="createNewTask()">{{$t('other.a2636')}}</el-button>
              </div>
          </div>
      </div>
      <div class="conditionArea">
          <div>
            <span class="ginn">{{$t('other.a2644')}}：<el-input style="width:150px;" size="mini" v-model="dataParams.taskId" :placeholder="$t('other.a2644')"></el-input></span>
            <span class="ginn">{{$t('other.a55')}}：
                <el-select size="mini" v-model="dataParams.status" :placeholder="$t('other.a55')">
                    <el-option :label="$t('other.a358')" value='null'></el-option>
                    <el-option :label="$t('other.a2641')" value="0"></el-option>
                    <el-option :label="$t('other.a2642')" value="1"></el-option>
                    <el-option :label="$t('other.a1064')" value="2"></el-option>
                    <el-option :label="$t('other.a2643')" value="3"></el-option>
                </el-select>
            </span>
          </div>
          <!-- <div class="btn">
              <el-button v-if="isSeller" size="mini" type="primary" @click="dialogVisible=true">卖家创建新任务</el-button>
          </div> -->
      </div>
      <div style="margin-bottom:10px;font-size:14px;">{{$t('other.a964')}}{{count}}{{$t('other.a707')}}</div>
      <div style="margin-right:10px;">
          <el-table
            :data="taskList"
            size='mini'
            border
            >
            <el-table-column  :label="$t('other.a2644')" >
                <template slot-scope="props">
                    <span>TASK{{props.row.taskId}}</span>
                </template>
            </el-table-column>
            <el-table-column  :label="$t('other.a2637')" >
                <template slot-scope="props">
                    <span>{{props.row.taskType.taskName}}</span>
                </template>
            </el-table-column>
            <el-table-column  :label="$t('other.a583')" >
                <template slot-scope="props">
                    <span>{{descText[props.row.taskStatus]}}</span>
                </template>
            </el-table-column>
            <el-table-column  :label="$t('other.a2645')" >
                <template slot-scope="props">
                    <span>{{text[props.row.finishStatus]}}</span>
                </template>
            </el-table-column>
            <el-table-column  :label="$t('other.a2658')" >
                <template slot-scope="props">
                    <div>{{$t('other.a2659')}} {{props.row.taskType.charge}}{{$t('other.a54')}}</div>
                    <div>{{$t('other.a2657')}} {{props.row.taskType.unfinishedCharge}}{{$t('other.a54')}}</div>
                </template>
            </el-table-column>
            
            
            <el-table-column  :label="$t('other.a2414')"  width="170">
                <template slot-scope="props" >
                    <span v-show="!props.row.checked">{{props.row.extraCharge}} {{$t('other.a54')}}</span>
                    <el-input style="width:60px" size="mini" v-show="props.row.checked" v-model="props.row.extraCharge" placeholder=""></el-input>
                    <span v-show="!isSeller && !props.row.checked && props.row.extraConfirm == 0 && props.row.finishStatus == 0" @click="actveBtn(props.row,props.$index)"><i class="el-icon-edit" ></i></span>
                    <span v-show="props.row.checked" class="btnItem" @click="operate(props.row,props.$index,0)">{{$t('other.a38')}}</span>
                    <span v-show="props.row.checked" class="btnItem" @click="operate(props.row,props.$index,1)">{{$t('other.a146')}}</span>
                    <span class="btnItem" v-show="props.row.extraConfirm == 1 && props.row.extraCharge !== 0">{{$t('other.a925')}}</span>
                </template>
            </el-table-column>
            
            <el-table-column  :label="$t('other.a57')" >
                <template slot-scope="props">
                    <span>{{showTime(props.row.createTime)}}</span>
                </template>
            </el-table-column>
            <el-table-column  :label="$t('other.a33')" width="250">
                <template slot-scope="props">
                    <div class="display:flex;">
                        <span class="okmg"><el-button size="mini" type="primary" @click="viewDetail(props.row)">{{$t('other.a1105')}}</el-button></span>
                        <span v-if="isSeller && props.row.taskStatus == 2" class="okmg"><el-button size="mini" type="warning" @click="sellerConfirmTo(props.row)">{{$t('other.a2660')}}</el-button></span>
                        <span v-if="isSeller && props.row.taskStatus == 2" class="okmg"><el-button size="mini" type="info" @click="sellerReturTo(props.row)">{{$t('other.a2661')}}</el-button></span>
                        <span v-if="isSeller  && props.row.extraConfirm == 0 && props.row.extraCharge !== 0" class="okmg"><el-button size="mini"  type="danger" @click="sellerConfirmExtra(props.row)">{{$t('other.a2662')}}</el-button></span>
                        <span v-if="isSeller && props.row.finishStatus == 0 && props.row.taskStatus == 0" class="okmg"><el-button size="mini" type="info" @click="sellerDelete(props.row)">{{$t('other.a2663')}}</el-button></span>
                        <span v-if="!isSeller && props.row.taskStatus == 0" class="okmg"><el-button size="mini" type="danger" @click="storeRecipt(props.row)">{{$t('other.a2664')}}</el-button></span>
                        <span v-if="!isSeller && props.row.taskStatus == 0" class="okmg"><el-button size="mini" type="info">{{$t('other.a2665')}}</el-button></span>
                        <span v-if="!isSeller && props.row.taskStatus !== 3 && props.row.finishStatus == 0 && props.row.taskStatus !== 0" class="okmg"><el-button size="mini" type="warning" @click="confirStatus(props.row)">{{$t('other.a2666')}}</el-button></span>
                        <span v-if="!isSeller && props.row.finishStatus !== 0 && props.row.taskStatus !== 3" class="okmg"><el-button size="mini" type="danger" >{{$t('other.a1064')}}</el-button></span>
                    </div>
                </template>
            </el-table-column>
           
           
          </el-table>
      </div>
      
      <div class="Pager">
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" 
        :page-sizes="[10,30,50]" :page-size="dataParams.offset" layout="total, sizes, prev, pager, next, jumper" :total="count">
        </el-pagination>
      </div>
  </div>
</template>

<script>
import storeTaskApi from '../../api/moudles/storeTasks.js'
import {CONUNTYOPTIONS} from '../../config/config.js'
import utils from '../../utils/utils.js'
export default {
data(){
return{
    dataParams:{
        end:null,
        offset:10,
        page:0,
        sellerUserId:null,
        shopIds:[],
        start:null,
        status:null,
        storeIds:null,
        taskId:null,
        userId:null,
    },
    userInfo:JSON.parse(localStorage.getItem('userInfo')),
    mainItem:null,
    taskmainItem:{
        unfinishedCharge:0,
        charge:0
    },
    activeList:[2,0],
    dialogVisible:false,
    dialogVisible2:false,
    dialogVisible3:false,
    count:0,
    ruleForm: {
        amount: '',
        contents: [{
            content:null,
            contentType:0,
            type:0,
        }],
        extraCharge: null,
        extraConfirm: null,
        finishStatus: 0,
        storeId: null,
        taskStatus: null,
        taskTypeId:null,
        userId: this.userId,
    },
    storeOptions:[],
    taskNameList:[],
    region:{
        storeId:null,
    },
    textarea3:null,
    taskList:[],
    taskTypeitem:null,
    isSeller:false,
    store:[],
    descText:{
        0:this.$t('other.a2641'),
        1:this.$t('other.a2642'),
        2:this.$t('other.a2667'),
        3:this.$t('other.a119'),

    },
    text:{
        0:this.$t('other.a1643'),
        2:this.$t('other.a2668'),
        1:this.$t('other.a2669'),

    },
    type:{
        0:this.$t('other.a2670'),
        1:this.$t('other.a499'),
        2:this.$t('other.a579'),
        3:this.$t('other.a2671'),

    },
    finishValue:null,
    finishStatus:[{
        label:this.$t('other.a2672'),
        value:0
    },{
        label:this.$t('other.a2668'),
        value:2
    },{
        label:this.$t('other.a2669'),
        value:1
    },],
    chatList:[]
    
    
}
},
created(){
    this.isSeller=this.userInfo.userPos == 'SELLER' ? true : false
    this.countryOptions = CONUNTYOPTIONS
    this.dataParams.userId=this.userInfo.userId
    this.dataParams.shopIds=this.userInfo.shopIds
    this.dataParams.storeIds=this.userInfo.storeIds
    this.storeOptions=this.userInfo.stores.filter(p => {
        if(p.isUsed){
            return p
        }
    })
    this.getTaskType('VN')
    this.getTask()
},
methods:{

    createNewTask(){
        if(!this.taskNameList.length){
            this.$message.warning(this.$t('other.a2673'))
            return
        }
        console.log('taskNameList',this.taskNameList,)
        this.taskTypeitem=this.taskNameList[this.activeList[1]]

        this.store=this.storeOptions.filter(p => {
            if(p.storeAddress == this.taskTypeitem.country){
                return p
            }
        })

        
        this.dialogVisible=true
    },
    viewDetail(item){
        console.log('item',item)
        this.chatList=item.contents
        this.dialogVisible3=true
    },
    operate(item,index,num){
        if(num == 0){
            console.log(item)
            item.extraCharge=Number(item.extraCharge)
            if(!item.extraCharge){
                this.$message.warning(this.$t('other.a2674'))
                item.extraCharge=null
                return
            }

            this.storeAddExtra(item)
            item.checked=false
            this.$set(this.taskList,index,item)

            
        }else if(num == 1){
            item.checked=false
            this.$set(this.taskList,index,item)
            this.getTask()
        }
        
    },
    actveBtn(item,index){
        console.log(item,index)
        item.checked=true
        this.$set(this.taskList,index,item)
    },
    handleSizeChange(val) {
    console.log(`每页 ${val} 条`);
    this.dataParams.offset =Number( `${val}`)
    this.handleCurrentChange()
    },
    //显示当前第几页
    handleCurrentChange(val) {
    let currentPage = (parseInt(`${val}`) - 1) * this.dataParams.offset
    this.dataParams.page=currentPage ? currentPage : 0
    this.getTask()
    
    },
    showTime(time){
        return utils.renderTime(time)
    },
    /*获取用户任务列表 */
    getTask(){
        storeTaskApi
        .getTask(this.dataParams)
        .then(res => {
        if(res.code === 200 ){
        console.log('desc',res.data)
        this.taskList=res.data.items
        this.taskList.forEach(p => {
            p.checked=false
        })
        this.count=res.data.count
        }else{
        this.$message.warning(res.msg)
        }
        })
    },

    
    

    /*新建任务 */
    createTask(){
        this.ruleForm.amount=this.taskTypeitem.charge
        this.ruleForm.taskTypeId=this.taskTypeitem.taskTypeId
        this.ruleForm.storeId=this.region.storeId
        this.ruleForm.userId=this.userInfo.userId
        if(!this.ruleForm.storeId){
            this.$$message.warning(this.$t('other.a2295'))
            return
        }

        
        storeTaskApi
        .createTask(this.ruleForm)
        .then(res => {
        if(res.code === 200 ){
        console.log('desc',res.data)
        this.$message.success(this.$t('other.a2675'))
        this.getTask()
        this.dialogVisible=false
        }else{
        this.$message.warning(res.msg)
        }
        })
    },
    /**根据国家获取任务类型 */
    getTaskType(id,index){
        
        let that=this
        that.activeList[1]=0
        that.taskNameList=[]
        storeTaskApi
        .getTaskType({
            country:id
        })
        .then(res => {
        if(res.code === 200 ){
        console.log('taskNameList',res.data)
        that.taskNameList=res.data
        if(that.taskNameList.length){
            that.taskmainItem={
                charge:that.taskNameList[0].charge,
                unfinishedCharge:that.taskNameList[0].unfinishedCharge
            }
        }else{
            that.taskmainItem=null
        }

        
        }else{
        this.$message.warning(res.msg)
        }
        })
    },
    /**卖家退回仓库确认 */
    sellerReturTo(item){
        item.userId=this.userInfo.userId
        storeTaskApi
        .sellerReturn(item)
        .then(res => {
        if(res.code === 200 ){
        console.log('desc',res.data)
        this.$message.success(this.$t('other.a2676'))
        this.getTask()
        }else{
        this.$message.warning(res.msg)
        }
        })
    },

    /**卖家确认任务完成,结算费用 */
    sellerConfirmTo(item){
        console.log(item)
        let ttp=item.finishStatus !== 1 ? item.taskType.charge : item.taskType.unfinishedCharge
        let extraCharge=item.extraCharge !== 0  && item.extraConfirm == 1 ? item.extraCharge : 0 
        let total=ttp+extraCharge

        let text=this.$t('other.a2677')+ttp+this.$t('other.a2678')+ extraCharge+this.$t('other.a2679')+total+this.$t('other.a2680')
        this.$confirm(text, this.$t("other.a142"), {
        confirmButtonText: this.$t('other.a235'),
        cancelButtonText: this.$t('other.a146'),
        type: 'warning'
        }).then(() => {

            item.userId=this.userInfo.userId
            storeTaskApi
            .sellerConfirmEnd(item)
            .then(res => {
            if(res.code === 200 ){
            console.log('desc',res.data)
            this.$message.success(this.$t('other.a2681'))
            this.getTask()
    
            }else{
            this.$message.warning(res.msg)
            }
            })
        })

       
    },

    confirStatus(item){
        console.log(item)
        if(item.extraCharge !==0 && item.extraConfirm == 0){
            this.$confirm(this.$t('other.a2682'), this.$t("other.a142"), {
            confirmButtonText: this.$t('other.a235'),
            cancelButtonText: this.$t('other.a146'),
            type: 'warning'
            }).then(() => {
                this.mainItem=item
                this.dialogVisible2=true
            })
            return
        }
        this.mainItem=item
        this.dialogVisible2=true
    },

    /**卖家删除任务 */
    sellerDelete(item){
        this.$confirm(this.$t('other.a608'), this.$t("other.a142"), {
        confirmButtonText: this.$t('other.a235'),
        cancelButtonText: this.$t('other.a146'),
        type: 'warning'
        }).then(() => {
            item.userId=this.userInfo.userId
            storeTaskApi
            .deleteTask(item)
            .then(res => {
            if(res.code === 200 ){
            this.$message.success(this.$t('other.a565'))
            this.getTask()
            }else{
            this.$message.warning(res.msg)
            }
            })
        })
    },

    /**卖家确认仓库提出的额外收费 */
    sellerConfirmExtra(item){
        let text=this.$t('other.a2683')+item.extraCharge +this.$t('other.a2684')
        this.$confirm(text, this.$t("other.a142"), {
        confirmButtonText: this.$t('other.a235'),
        cancelButtonText: this.$t('other.a146'),
        type: 'warning'
        }).then(() => {
            item.userId=this.userInfo.userId
            storeTaskApi
            .sellerConfirmExtra(item)
            .then(res => {
            if(res.code === 200 ){
            console.log('desc',res.data)
            this.$message.success(this.$t('other.a2685'))
            this.getTask()
            }else{
            this.$message.warning(res.msg)
            }
            })
        })
    },


    //仓库接单
    storeRecipt(item){
        console.log('item',item)
        this.$confirm(this.$t('other.a2686'), this.$t("other.a142"), {
        confirmButtonText: this.$t('other.a235'),
        cancelButtonText: this.$t('other.a146'),
        type: 'warning'
        }).then(() => {
            item.userId=this.userInfo.userId
            storeTaskApi
            .storeReceipt(item)
            .then(res => {
            if(res.code === 200 ){
            console.log('desc',res.data)
            this.$message.success(this.$t('other.a2687'))
            this.getTask()
            }else{
            this.$message.warning(res.msg)
            }
            })
        })
    },

    //向卖家提交额外费用的收费
    storeAddExtra(item){
        item.userId=this.userInfo.userId
        storeTaskApi
        .storeAddExtraFee(item)
        .then(res => {
        if(res.code === 200 ){
        console.log('desc',res.data)
        
        this.$message.success(this.$t('other.a2688'))
        }else{
        this.$message.warning(res.msg)
        }
        })
    },

    //仓库{{$t('other.a2660')}}进度
    storeComfir(){
        this.mainItem.finishStatus=this.finishValue
        this.mainItem.userId=this.userInfo.userId
        
        storeTaskApi
        .storeConfirm(this.mainItem)
        .then(res => {
        if(res.code === 200 ){
        console.log('desc',res.data)
        this.$message.success(this.$t('other.a232'))
        this.dialogVisible2=false
        this.getTask()
        }else{
        this.$message.warning(res.msg)
        }
        })
    },

    //发送留言信息
    sendMsg(){
        console.log(this.chatList)
        if(!this.textarea3){
            this.$message.warning(this.$t('other.a2689'))
            return
        }
        let params={
            content:this.textarea3,
            contentType:0,
            taskId:this.chatList[0].taskId,
            type:this.isSeller ? 1 : 2

        }

        

        storeTaskApi
        .sendMessage(params)
        .then(res => {
        if(res.code === 200 ){
        console.log('desc',res.data)
        let list=res.data.contents
        this.chatList.push(list[list.length-1])
        this.$message.success(this.$t('other.a719'))
        this.textarea3=null
        
        }else{
        this.$message.warning(res.msg)
        }
        })
    },




}
}

</script>
<style lang="scss" scoped>
.storeTasks{
    .btn{
        margin-right: 15px;
    }

    .title{
        font-size: 18px;
        font-weight: bold;
    }

    .test{
        color: red;
        font-size: 16px;
        padding: 3px 0;
    }

    .oiuk{
        background-color: #f7f8fa;
        box-sizing: border-box;
        padding: 5px;

        .taskItem{
            padding: 2px 10px;
            cursor: pointer;
        }

        .poom{
            display: flex;
            justify-content: flex-end;
        }

        .active{
            color: #fff;
            background-color: #409EFF;
            border-radius: 2px;
        }

        .tgrf{
            margin: 5px 0;
            padding-bottom: 10px;
        }
    }
    

    .sendBox{
        position: relative;

        .bbnt{
            position: absolute;
            right: 0;
            bottom: 0;
            display: flex;
            margin: 0 2px 2px 0;
        }

    }

  
    /deep/ .el-scrollbar__wrap{
        overflow-x: hidden;
        
    }

    .chatArea{
        border: 1px solid #eee;
    }

    .icon-kehuAx{
        margin: 0 10px;
    }

    .msgBox{
        color: #757575;
    }

    .msgWrap{
        padding: 8px 10px;
    }

    .sellerMsg{
        display: flex;
        justify-content: flex-start;
    }

    .contentBox{
        
    }
    .storeMsg{
        display: flex;
        justify-content: flex-end;
        text-align: right;
    }

    
    .okmg{
        margin:0  2px;
    }

    .el-icon-edit{
        color: royalblue;
        font-size: 14px;
        margin: 0 10px;
        cursor: pointer;
    }

    .btnItem{
        margin-left: 10px;
        cursor: pointer;
    }
    
    .Pager{
            position: fixed;
            bottom: 0;
            left: 205px;
            right: 0;
            height: 40px;
            line-height: 40px;
            background-color: #fff;
            text-align:right;
            
        }
    
    .conditionArea{
        margin: 20px 0;
        display: flex;
        justify-content: flex-start;
        align-items: center;
        
        .ginn{
            margin-right: 20px;
        }
    }

}
</style>